import { useNavigate } from "react-router-dom";
import { ScreenRates } from "@/components/noxn/ScreenRates";
import { AccountLayout } from "@/components/account/AccountLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AccountRates() {
    usePageMeta({ title: "Screen rates · NOXN", description: "Live daily rates for every NOXN screen." });
    const navigate = useNavigate();
    return (
        <AccountLayout title="Screen rates">
            <div data-testid="account-rates-page" className="max-w-5xl">
                <ScreenRates compact onBegin={(s) => navigate(s?.id ? `/account/book?screen=${s.id}` : "/account/book")} />
            </div>
        </AccountLayout>
    );
}
